import Insurance from '@/modules/common/common/models/APP/Insurance'
import Insured from '@/modules/common/common/models/APP/Insured'
import { ForWhomEnum, UserRoleEnum } from '@/modules/core/models/enums'

export class RaterAnswers {
  public quotationId: string | null
  public businessLine: string | null
  public billingCycle: string | null // ? used?
  public product: Insurance | null

  startDate: Date | null
  policyHolderPostal: string | null
  forWhomPeople!: number
  private _forWhom!: string
  private _insureds!: Insured[]
  private _holder = new Insured()

  constructor(data: Partial<RaterAnswers> = {}) {
    this.quotationId = data?.quotationId ?? null
    this.businessLine = data.businessLine ?? null
    this.billingCycle = data.billingCycle ?? ''
    this.product = data?.product ?? null

    this.startDate = data.startDate ?? null

    this.insureds = data.insureds
    this.holder = data.holder
    this.policyHolderPostal = data.policyHolderPostal ?? null
  }

  get forWhom(): string | null {
    return this._forWhom
  }

  set forWhom(value: string | null | undefined) {
    if (value) {
      const holderIsInsured = value === ForWhomEnum.NOT_ME
      this.holder.role = holderIsInsured
        ? UserRoleEnum.HOLDER_NOT_INSURED
        : UserRoleEnum.HOLDER_INSURED
    }

    this._forWhom = value ?? ForWhomEnum.ME
  }

  set insureds(value: Insured[] | undefined) {
    this._insureds = value?.map((insured) => new Insured(insured)) ?? []
  }
  get insureds(): Insured[] {
    return this._insureds
  }

  set holder(value: Insured | undefined) {
    this._holder.updateAttributes(value ?? {})
  }
  get holder(): Insured {
    return this._holder
  }

  updateAttributes(newAttributes: Partial<RaterAnswers>) {
    Object.assign(this, newAttributes)
  }

  updateInsuredAttributes(insuredIndex: number, insuredData: Partial<Insured>) {
    if (this.holder.role === UserRoleEnum.HOLDER_INSURED && insuredIndex === 0) {
      this.holder.updateAttributes(insuredData)
    }

    this.insureds[insuredIndex].updateAttributes(insuredData)
  }
}
